"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InputPrefix_1 = __importDefault(require("./InputPrefix"));
exports.default = InputPrefix_1.default;
